import { render, staticRenderFns } from "./UploadImageAndPreview2.vue?vue&type=template&id=046bcdff&"
import script from "./UploadImageAndPreview2.vue?vue&type=script&lang=js&"
export * from "./UploadImageAndPreview2.vue?vue&type=script&lang=js&"
import style0 from "./UploadImageAndPreview2.vue?vue&type=style&index=0&id=046bcdff&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports